import { SimpleDashboardContent } from 'features/dashboard/DashboardContent';
import { GenericViewHeader } from 'back-office/shared/components/GenericViewHeader';
import { BarChart3, Construction } from 'lucide-react';

/** Page Statistiques du back-office — en cours de développement. */
export default function BoStatisticsView() {
  return (
    <SimpleDashboardContent>
      <GenericViewHeader title="Statistiques" icon={BarChart3} section="Pilotage" />
      <div className="flex min-h-[420px] flex-col items-center justify-center rounded-2xl border-2 border-dashed border-primary/20 bg-primary/[0.03] p-12 text-center">
        <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-primary/10">
          <Construction className="h-8 w-8 text-primary" />
        </div>
        <h3 className="mt-5 text-lg font-semibold text-gray-900">
          En cours de développement
        </h3>
        <p className="mt-2 max-w-md text-sm text-gray-500">
          Les tableaux de bord et indicateurs d'activité du back-office arrivent bientôt.
        </p>
      </div>
    </SimpleDashboardContent>
  );
}
